import { axios } from "../../../packs/axios";

export const brandsMarketplaceAPI = {
    /**
   * GET All brand displays for each row by state, previously_sponsored, & in_store
   * @constructor
   * @returns {object} {
   * "states":[{
   *    "state_name":[{
   *        "id":23,
   *        "display_name":"Awesome Display",
   *        "image":"https://cdn.springbig.cloud/development/branddisplay/52849e58/5d1c/4d66/82a0/6841c59365f8/thumb/Hapy-monday-memes.jpeg",
   *        "advertiser_created_at":"2021-06-21 15:23:49 +00:00"}]
   *    }],
   * "previously_sponsored":[{
   *    "id":23,
   *    "display_name":"Awesome Display",
   *    "image":"https://cdn.springbig.cloud/development/branddisplay/52849e58/5d1c/4d66/82a0/6841c59365f8/thumb/Hapy-monday-memes.jpeg",
   *    "advertiser_created_at":"2021-06-21 15:23:49 +00:00"
   * }],
   * "in_store":[{
   *    "id":23,
   *    "display_name":"Awesome Display",
   *    "image":"https://cdn.springbig.cloud/development/branddisplay/52849e58/5d1c/4d66/82a0/6841c59365f8/thumb/Hapy-monday-memes.jpeg","advertiser_created_at":"2021-06-21 15:23:49 +00:00"}
   * ]}
  **/
    getAllBrandDisplays() {
        return axios.get('/api/v3/brand_displays').then((resp) => {
            return resp.data
        });
    },
  /**
   * GET Main Navigation Demo Brand Display
   * @constructor
   * @returns {object} {
   * "name":"brand marketplace",
   * "id":123,
   * "description":"welcome to the brand marketplace",
   * "primary_image":{
   *    "id":99,
   *    "url":"https://cdn.springbig.cloud/original/default_demo_image.png",
   *    "thumb":"https://cdn.springbig.cloud/thumb/default_demo_image.png"
   * },
   * "secondary_images":[]
   * }
  **/
  getDemoBrandDisplay() {
    return axios.get('/api/v3/brand_displays/demo_show').then((resp) => {
        return resp.data
    });
  },
  /**
   * GET Individual brand display
   * @constructor
   * @param {number} id - 99.
   * @returns {object} {
    * "id":999,
    * "name":"Burton Brand",
    * "description":"The coolest brand in town",
    * "last_merchant_sponsor_request_at":"2021-05-17T03:50:33.000Z",
    * "last_merchant_inventory_request_at":"2021-05-17T03:50:33.000Z",
    * "primary_image":{
    *   "id":222,
    *   "url":"https://cdn.springbig.cloud/development/original/Planet_Purp_MMS_1.png",
    *   "thumb":"https://cdn.springbig.cloud/development/thumb/Planet_Purp_MMS_1.png"
    * },
    *   "secondary_images":[{
    *   "id":765,
    *   "url":"https://cdn.springbig.cloud/development/original/Planet_Purp_MMS_1.png",
    *   "thumb":"https://cdn.springbig.cloud/development/thumb/Planet_Purp_MMS_1.png"
    *   }]
    * }
  **/
   getBrandDisplay(brandDisplayId) {
    return axios.get(`/api/v3/brand_displays/${brandDisplayId}`).then((resp) => {
        return resp.data
    });
  },
  /**
   * Post Brands Marketplace Action
   * @constructor
   * @marketplaceAction {object} marketplaceAction - { brand_display_id: 99, action_type: sponsor_requests, inventory_requests or views }
   * @returns {object} {
    * "id":123,
    * "brand_display_id":99,
    * "views":44,
    * "sponsor_requests":55,
    * "inventory_requests":33,
    * "last_view":"2021-05-02T19:45:58.000Z",
    * "last_sponsor_request":"2021-04-02T19:45:58.000Z",
    * "last_inventory_request":"2021-06-02T19:45:58.000Z"
   * }
  **/
  postMarketplaceAction(marketplaceAction) {
    return axios.post('/api/v3/marketplace_actions', marketplaceAction)
      .then((resp) => resp.data);
  },
  /**
   * Post Brand Referral
   * @constructor
   * @form {object} form - { brand_name: 'cali buds', contact_name: 'Jack Smith', phone_number: 3213211234, email: 'johnsmith@gmail.com'}
   * @returns {object}
   * "status": 201
  **/
  postBrandReferral(form) {
    return axios.post('/api/v3/brand_referrals', form)
      .then((resp) => resp)
  }
}
